module.exports = __webpack_public_path__ + "167adb33295d0a74c8ffe4710e3d73b7.svg";